export class DisabledCoupon {
    constructor() {
        this.type = "Disabled";
        this.state = { type: "Disabled" };
    }
}
